// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__drEZT","content":"LoadingAlert_content__1dUiE"};